import { InputBaseComponentProps, InputBaseProps } from '@mui/material';
import React from 'react';

import { MaskedInput } from '../MaskedInput/MaskedInput';
import { TextField, TextFieldProps } from '../TextField/TextField';

interface MaskedDecimalInputProps extends InputBaseComponentProps {
  /** @default 2 - two decimal points */
  scale?: number;
  ref?: InputBaseProps['ref'];
}

export const MaskedDecimalInput = (props: MaskedDecimalInputProps) => {
  const { scale, ref, ...inputProps } = props;
  return (
    <MaskedInput
      inputProps={inputProps}
      ref={ref}
      maskProps={{ mask: Number, overwrite: true, radix: '.', scale: typeof scale === 'number' ? scale : 2 }}
    />
  );
};

export const MaskedNumericInput = (props: InputBaseComponentProps & { ref?: InputBaseProps['ref'] }) => {
  const { ref, ...inputProps } = props;
  return <MaskedInput ref={ref} inputProps={inputProps} maskProps={{ mask: Number, overwrite: true }} />;
};

export interface NumericTextFieldProps extends Omit<TextFieldProps, 'slotProps'> {
  currency?: boolean;
}

export const NumericTextField = (props: NumericTextFieldProps) => {
  const { currency, ...restProps } = props;

  return (
    <TextField
      slotProps={{
        input: {
          inputComponent: currency ? MaskedDecimalInput : MaskedNumericInput
        }
      }}
      {...restProps}
    />
  );
};
